import React from 'react';

import { type BaseSvgProps, colorToHexCode } from '../../utils';

export const Download = ({
  width = 12,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}: BaseSvgProps) => (
  <svg
    data-testid={testId}
    width={width}
    height={width}
    viewBox="0 0 27 27"
    className="shrink-0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3755 20.3838H8.12549L8.12549 18.9341L19.3755 18.9341V20.3838Z"
      fill={primaryColorHexCode}
    />
    <path
      d="M18.3703 11.0957L19.3755 12.1008L13.75048 17.7258L8.12549 12.1008L9.13064 11.0957L12.99662 15.039V6.5H14.50435V15.039L18.3703 11.0957Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
